// Sorted as it is in designs so we can create the array direct from the enum
export enum PeriodTypes {
  OPEN = 'OPEN',
  SPLIT = 'SPLIT',
  OPEN24H = 'OPEN24H',
  CLOSED = 'CLOSED',
}
